export default __webpack_public_path__ + "static/azure-logo-29106423377bd0d35431c5bc8a587ff5.png";